import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthErrorType } from '../shared/components/auth-error-display/auth-error-display.component';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    standalone: false
})
export class NotFoundComponent {
  type: AuthErrorType;
  message?: string;
  attemptedUrl?: string;

  constructor(route: ActivatedRoute, router: Router) {
    const navState = router.getCurrentNavigation()?.extras.state;
    const routeType = route.snapshot.data['type'] as AuthErrorType | undefined;
    this.type = navState?.['type'] ?? routeType ?? 'error';
    this.message = navState?.['message'] as string | undefined;
    this.attemptedUrl = navState?.['attemptedUrl'] as string | undefined;
  }
}
